import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseComponent } from 'src/app/moov-common/base/base.component';


@Component({
  selector: 'app-make-moov-header-web',
  templateUrl: './make-moov-header-web.component.html',
  styleUrls: ['./make-moov-header-web.component.scss']
})
export class MakeMoovHeaderWebComponent extends BaseComponent implements OnInit {

  @Input() firstName: string;
  @Input() lastName: string;
  @Input() initials: string;
  @Input() color: string;
  @Input() wizardState: number;
  @Output() closeWizardEvent = new EventEmitter();
  constructor() {
    super();
   }

  ngOnInit(): void {
    super.ngOnInit();
  }

  closeWizard() {
    this.closeWizardEvent.emit();
  }

}
